// extracted by mini-css-extract-plugin
module.exports = {"datagridCell":"DatagridCell_datagridCell__7tVa0"};